import { QueovalBase, QueovalItem } from "..";

/**
 * Modèle pour la gestion des cursus (= cycles) depuis la gestion des formations
 **/
export class CursusModel extends QueovalBase {
  public Cursus: Cursus;
  public ListStages: Array<QueovalItem>;

  //#region données pour la duplication

  public WithTrainer: boolean;
  public WithResp: boolean;
  public WithLocation: boolean;
  public WithReserv: boolean;
  public WithTache: boolean;
  public IdCursusToDuplicate: string;

  //#endregion
}

export class Cursus {
  public Ident: string;
}
